import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SecretDetectionIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Top right hexagon */}
    <path
      d="M27.05 19.6L27.03 23.82C27.03 23.99 26.94 24.15 26.79 24.23L23.13 26.32C22.98 26.41 22.8 26.41 22.65 26.32L19.01 24.19C18.86 24.1 18.77 23.94 18.77 23.77L18.79 19.55C18.79 19.38 18.88 19.22 19.03 19.14L22.69 17.05C22.84 16.96 23.02 16.96 23.17 17.05L26.81 19.17C26.96 19.26 27.05 19.43 27.05 19.6Z"
      fill="#17E88F"
    />

    {/* Top left hexagon */}
    <path
      d="M20.18 7.61L20.16 11.82C20.16 11.99 20.07 12.15 19.92 12.24L16.26 14.33C16.11 14.42 15.93 14.41 15.78 14.33L12.16 12.22C12.01 12.13 11.92 11.97 11.92 11.8V7.57C11.92 7.4 12.01 7.24 12.16 7.15L15.83 5.07C15.98 4.98 16.16 4.98 16.31 5.07L19.94 7.19C20.09 7.28 20.18 7.44 20.18 7.61Z"
      fill="#17E88F"
    />

    {/* Bottom left hexagon */}
    <path
      d="M13.28 19.55L13.26 23.77C13.26 23.94 13.17 24.1 13.02 24.18L9.36 26.27C9.21 26.36 9.03 26.36 8.88 26.27L5.24 24.14C5.09 24.05 5 23.89 5 23.72L5.02 19.5C5.02 19.33 5.11 19.18 5.26 19.09L8.92 17C9.07 16.91 9.25 16.91 9.4 17L13.04 19.13C13.19 19.22 13.28 19.38 13.28 19.55Z"
      fill="#17E88F"
    />

    {/* Center connecting piece */}
    <path
      d="M22.5 13.43L16.59 9.98C16.28 9.8 15.9 9.8 15.59 9.98L9.66 13.36C9.35 13.54 9.16 13.87 9.16 14.22V21.05C9.16 21.41 9.32 21.74 9.63 21.92L15.53 25.36C15.84 25.54 16.22 25.54 16.53 25.36L22.46 21.98C22.77 21.8 22.96 21.47 22.96 21.12V14.3C22.98 13.94 22.8 13.61 22.5 13.43Z"
      fill="#0FB870"
    />

    {/* Darker accents */}
    <path
      d="M13.26 23.77C13.26 23.85 13.24 23.93 13.2 24L9.63 21.92C9.32 21.74 9.13 21.41 9.13 21.05L9.16 16.93C9.24 16.93 9.32 16.96 9.4 17L13.04 19.13C13.19 19.22 13.28 19.38 13.28 19.55L13.26 23.77Z"
      fill="#0D9359"
    />
    <path
      d="M20.11 12.04C20.06 12.12 20 12.19 19.92 12.24L16.26 14.33C16.11 14.42 15.93 14.41 15.78 14.33L12.16 12.22C12.08 12.18 12.02 12.11 11.98 12.04L15.59 9.98C15.9 9.8 16.28 9.8 16.59 9.98L20.11 12.04Z"
      fill="#0D9359"
    />
    <path
      d="M22.98 16.99L22.96 21.12C22.96 21.47 22.77 21.8 22.46 21.98L18.85 24.04C18.8 23.96 18.77 23.87 18.77 23.77L18.79 19.55C18.79 19.38 18.88 19.22 19.03 19.14L22.69 17.05C22.78 17 22.88 16.97 22.98 16.99Z"
      fill="#0D9359"
    />
  </SvgIcon>
);

export default SecretDetectionIcon;
